module.exports = __webpack_public_path__ + "img/BlinkArt_Sword2_Yellow.5a77a44a.png";